import * as React from 'react'

import { observer } from 'mobx-react'
import classnames from 'classnames'

class Pagination extends React.Component<{ numberOfPages: number; currentPage: number; onClick: any }, {}> {
    public render() {
        const { numberOfPages, currentPage, onClick } = this.props
        if (numberOfPages == 0) return null
        return (
            <div className="pagination">
                <ul className="MarkupPagerNav" role="navigation" aria-label="Pagination links">
                    {Array.from(Array(numberOfPages + 1).keys())
                        .filter(p => p > 0)
                        .map(p => (
                            <li
                                className={classnames({
                                    MarkupPagerNavOn: currentPage == p,
                                    MarkupPagerNavFirst: p == 1,
                                    MarkupPagerNavFirstNum: p == 1,
                                    MarkupPagerNavLastNum: p == numberOfPages,
                                })}
                                key={p}
                                onClick={() => {
                                    onClick(p)
                                }}
                            >
                                <a>
                                    <span>{p}</span>
                                </a>
                            </li>
                        ))}
                </ul>
            </div>
        )
    }
}

export default observer(Pagination)



// WEBPACK FOOTER //
// ./react/src/components/Pagination.tsx